import Map from "@/utils/Map";
import * as egm96 from "egm96-universal";
import Map_DynamicElementEvents from "@/utils/map/Map_DynamicElementEvents";
import Map_DynamicElementMaterial from "@/utils/map/Map_DynamicElementMaterial";
import Map_DynamicElementPoint from "@/utils/map/Map_DynamicElementPoint.js";
import Map_DynamicElementPolygon from "@/utils/map/Map_DynamicElementPolygon.js";
import Map_DynamicElementLine from "@/utils/map/Map_DynamicElementLine.js";
import { MapElementType, InfosDraw } from "@/utils/constant/settings_constantes";


export default class Map_DynamicElementGeometry {
  infos;
  controlspoints;
  sauvcontolpoints;
  controlspointsEntities;

  events;
  material;
  point;
  line;
  polygon;
  visible;
  active;
  callBack;
  datasource;
  pickedInfos;
  timeriD;
  tick;
  isTypeVisible;
  isUpdated;

  constructor(viewer, datasource, callBack, isTypeVisible) {
    this.viewer   = viewer;
    this.events   = new Map_DynamicElementEvents(this);
    this.point    = new Map_DynamicElementPoint(this);
    this.polygon  = new Map_DynamicElementPolygon(this);
    this.line     = new Map_DynamicElementLine(this);
    this.material = new Map_DynamicElementMaterial(this.events);

    this.visible                  = true;
    this.active                   = true;
    this.datasource               = datasource;
    this.callBack                 = callBack;
    this.timeriD                  = undefined;
    this.tick                     = 5000;
    this.isAbsolute               = false;
    this.controlspointsEntities   = [];
    this.controlspoints           = [];
    this.sauvcontolpoints         = [];
    this.isTypeVisible            = isTypeVisible;
    this.isUpdated                = false;

    this.infos = {
      name: "",
      id: "",
      type: "",
      color: "",
      point: { lat: 0.0, lon: 0.0, height: { WGS: 0.0, ASL: 0.0, AGL: 0.0 } },
      line: { length: 0.0 },
      polygon: { length: 0.0, area: 0.0 },
      ground: { height: 0.0 },
    };

    this.timeriD = setInterval(() => {
      this.forceUpdateInfos();
    }, this.tick);

    this.polygon.addInsertPoint();
  }

  cancel() {
    this.restore();
    this.forceUpdateInfos();
    if (this.events.isFreeze()) {
      this.events.freezeCamera(false);
    }
    if (this.events.isInsert()) {
      this.callBack(true);
    }
  }

  getPickedInfos() {
    return this.pickedInfos;
  }

  getInfos() {
    return this.infos;
  }

  async forceUpdateInfos(force) {
    if(force === undefined){
      force = false;
    }

    if(this.getVisibility() === false && force === false) {
      return;
    }
    if(this.events.isOpen() || force === true){
      for (let idx = 0; idx < this.controlspoints.length; idx++) {
        await this.updateHeightGround(idx);
      }

      if (this.getType() === MapElementType.Point) {
        this.updateInfosHeight(0);
      }
      if (this.getType() === MapElementType.Ligne) {
        this.infos.line.length = this.line.getLength();
      }
      if (this.getType() === MapElementType.Polygone) {
        this.infos.polygon.area = this.polygon.getArea();
        this.infos.polygon.length = this.polygon.getLength();
      }
      this.isUpdated = true;
      //this.viewer.render();
      //
      this.events.updateCustomMapElement();
      this.viewer.scene.requestRender();
    }
  }

  updateInfosHeight(index) {
    if (this.infos.point["height"].WGS < this.getControlPointHeight(index)) {
      this.infos.point["height"].WGS = this.getControlPointHeight(index);
    }
    if (this.isAbsolute == true) {
      this.infos.point["height"].AGL =
        this.infos.point["height"].WGS - this.getControlPointHeight(index);
    } else {
      this.infos.point["height"].WGS =
        this.infos.point["height"].AGL + this.getControlPointHeight(index);
    }

    this.updateEgm96(index);
  }

  updateEgm96(index) {
    const cartographic = this.getControlPoint(index);
    this.infos.point["height"].ASL = egm96.ellipsoidToEgm96(
      cartographic.latitude,
      cartographic.longitude,
      this.infos.point["height"].WGS
      //cartographic.height
    );
  }

  updateWGS84(index) {
    const cartographic = this.getControlPoint(index);
    this.infos.point["height"].WGS = egm96.egm96ToEllipsoid(
      cartographic.latitude,
      cartographic.longitude,
      this.infos.point["height"].ASL
    );
  }

  updateInfos(key) {

    // console.log("updateInfos " + key);
    const index = 0;

    if (key === undefined) {
      return;
    }
    if (key.toLowerCase() == "lat" || key.toLowerCase() == "lon") {
      let cartographic = new Cesium.Cartographic(
        this.infos.point.lon,
        this.infos.point.lat,
        0
      );
      if (Cesium.defined(cartographic)) {
        this.setControlPoint(index, cartographic);
        this.updateHeightGround(index);
      }
    }
    if (key.toLowerCase() == "wgs") {
      this.infos.point["height"].AGL =
        this.infos.point["height"].WGS - this.getControlPointHeight(0);
      this.updateEgm96(index);
    }
    if (key.toLowerCase() == "agl") {
      this.infos.point["height"].WGS =
        this.infos.point["height"].AGL + this.getControlPointHeight(0);
      this.updateEgm96(index);
    }
    if (key.toLowerCase() == "asl") {
      this.updateWGS84(index);
      this.infos.point["height"].AGL =
        this.infos.point["height"].WGS - this.getControlPointHeight(0);
    }
  }

  update(pickedInfos, isOpen) {

    this.events.isopen = isOpen;
    this.pickedInfos = pickedInfos;

    if (this.events.isInsert()) {
      if (this.events.isValidate()) {
        if(this.getType() === MapElementType.Ligne &&  this.events.indexControlPoint < 1) {
          return;
        }
        if (this.getType() === MapElementType.Polygone &&  this.events.indexControlPoint < 2) {
          return;
        }
        //valider l'insertion du MapElement
        this.events.setInfosDrawHelp(InfosDraw.Clear);
        //this.forceUpdateInfos();
        this.callBack(false);
      }
    }

    if (isOpen) {

      //fenetre ouverte
      this.events.setInfosDrawHelp(InfosDraw.Clear);

      if (this.getType() !== MapElementType.Point && this.events.isFreeze() == false) {
        this.polygon.getBorderPicked();
      }

      if (this.events.isControlPointClickLeft() && this.events.isFreeze() == false) {
        this.sauve();
        this.events.freezeCamera(true);
        // console.log("move");
      } else if (this.events.isFreeze() || this.events.isControlPointPicked()) {
        this.events.setInfosDrawHelp(InfosDraw.MovePoint);
        this.viewer.canvas.style.cursor = "move";

        if (this.events.isControlPointClicRight()) {
          this.openContextMenu();
        }

      } else {
        if (this.events.isBorderHover()) {
          this.events.setInfosDrawHelp(InfosDraw.InsertPoint);
        }
        if (this.events.isBorderClickLeft()) {
          this.polygon.addPointToPoly();
          this.pickedInfos.leftDown = false;
          this.events.updateCustomMapElement(true);
        }
      }
    }

    if (this.events.isFreeze() && this.pickedInfos.leftDown == false) {
      //fin deplacement point
      // console.log("fin deplacement");
      this.events.freezeCamera(false);
      this.viewer.canvas.style.cursor = "";
      this.events.updateCustomMapElement(true);
    }

    if (this.events.isFreeze() || this.events.isInsert()) {
      //// console.log("updateGeomPoint");
      this.updateGeomPoint(this.events.getIndexControlPoint());
      this.polygon.isValid();
    }

    if (this.events.isInsert()) {
      if (this.getType() !== MapElementType.Point) {
        if (this.pickedInfos.leftDown == true) {
          //ajout du point
          if(this.polygon.getinsertPointDistance() > this.events.distmin) {
            if (this.getType() === MapElementType.Polygone &&  this.events.indexControlPoint === 0) {
              this.events.setInfosDrawHelp(InfosDraw.AddPointMore);
            }
            else {
              this.events.setInfosDrawHelp(InfosDraw.Finish);
            }
            this.events.indexControlPoint += 1;
          }
          this.pickedInfos.leftDown = false;
        }
      }
    }
  }

  updateGeomPoint(index) {
    let cartographic = this.getPickedPosition();
    //// console.log(cartographic);
    if (Cesium.defined(cartographic)) {
      if (this.controlspoints.length <= index) {
        this.addControlPoint(cartographic);
      } else {
        this.setControlPoint(index, cartographic);
        this.forceUpdateInfos(true);
      }
    }
  }

  moveUp(cartesian3, decal) {
    const transform = Cesium.Transforms.eastNorthUpToFixedFrame(cartesian3);
    const coord = Cesium.Matrix4.multiplyByPoint(
      transform,
      new Cesium.Cartesian3(0, 0, decal),
      new Cesium.Cartesian3()
    );
    return coord;
  }

  getPickedPosition() {
    return this.pickedInfos.position;
  }

  getType() {
    return this.infos.type;
  }

  isValid() {}

  getWKT() {
    let wkt = "";
    if (this.getType() === MapElementType.Point) {
      wkt = this.point.getWKT();
    }
    if (this.getType() === MapElementType.Ligne) {
      wkt = this.line.getWKT();
    }
    if (this.getType() === MapElementType.Polygone) {
      wkt = this.polygon.getWKT();
    }
    return wkt;
  }

  getVisibility() {
    return this.isTypeVisible(this.getType()) && this.active;
  }

  getControlPointVisibility() {
    return this.getVisibility() && this.isUpdated === true && this.events.isOpen();
  }

  setVisibility(isVisble) {
    this.visible = isVisble;
  }

  setActive(isActive) {
    this.active = isActive;
  }

  setType(type) {
    this.infos.type = type;
  }

  setColor(color) {
    this.infos.color = color;
    this.material.setColor(color);
  }

  setAlpha(alpha) {
    this.material.setAlpha(alpha);
  }

  setSize(size) {
    this.material.setSize(size);
  }

  setAbsolute(isabsolute) {
    this.isAbsolute = isabsolute;
  }

  getGeomHeightWGS(isContour) {
    if (isContour == undefined) {
      isContour = false;
    }

    if (this.getType() === MapElementType.Point) {
      const cartographic = this.getControlPoint(0);
      let cartesian = undefined;
      if (Cesium.defined(cartographic)) {
        if (this.isAbsolute == true) {
          cartesian = Cesium.Cartesian3.fromDegrees(
            cartographic.longitude,
            cartographic.latitude,
            this.infos.point["height"].WGS
          );
        } else {
          cartesian = Cesium.Cartesian3.fromDegrees(
            cartographic.longitude,
            cartographic.latitude,
            cartographic.height + this.infos.point["height"].AGL
          );
        }
      } else {
        cartesian = new Cesium.Cartesian3.fromDegrees(0, 0, 0);
      }
      return cartesian;
    }
    if (this.getType() === MapElementType.Polygone) {
      //3d pour voler vers
      let is2d = false;
      let cartesians = undefined;
      let coordinates = this.getControlPointArray(is2d, isContour);

      if (is2d) {
        cartesians = Cesium.Cartesian3.fromDegreesArray(coordinates);
      } else {
        cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
      }

      if (isContour == false) {
        const polygonHierarchy = new Cesium.PolygonHierarchy(cartesians);
        return polygonHierarchy;
      } else {
        return cartesians;
      }
    }
    if (this.getType() === MapElementType.Ligne) {
      //3d pour voler vers
      let is2d = false;
      let cartesians = undefined;
      const coordinates = this.getControlPointArray(is2d);

      if (is2d) {
        cartesians = Cesium.Cartesian3.fromDegreesArray(coordinates);
      } else {
        cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
      }
      return cartesians;
    }
  }

  getControlPointHeight(index) {
    if (this.controlspoints.length > index) {
      return this.controlspoints[index].height;
    } else {
      return 0;
    }
  }

  getControlPoint(index) {
    if (index === undefined) {
      index = 0;
    }
    if (this.controlspoints.length > index) {
      return this.controlspoints[index];
    } else {
      return new Cesium.Cartographic(0, 0, 0);
    }
  }

  getControlPointCartesian(index) {
    const cartographic = this.getControlPoint(index);
    const cartesian = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    return cartesian;
  }

  getControlPointArray(is2D, isContour) {
    if (is2D === undefined) {
      is2D = false;
    }

    let type = this.getType();
    if (isContour == true) {
      type = MapElementType.Ligne;
    }

    let coordinates = [];
    this.controlspoints.forEach((controlspoint) => {
      if (controlspoint !== undefined) {
        coordinates.push(controlspoint.longitude);
        coordinates.push(controlspoint.latitude);
        if (is2D == false) {
          coordinates.push(controlspoint.height);
        }
      } else {
        //control points removed
        coordinates.push(0);
        coordinates.push(0);
        if (is2D == false) {
          coordinates.push(0);
        }
      }
    });

    if (this.controlspoints.length == 0 && type === MapElementType.Polygone) {
      coordinates.push(0);
      coordinates.push(0);
      if (is2D == false) {
        coordinates.push(0);
      }
      coordinates.push(0);
      coordinates.push(0);
      if (is2D == false) {
        coordinates.push(0);
      }
    }

    if (
      (this.controlspoints.length == 1 && type === MapElementType.Polygone) ||
      (this.controlspoints.length == 0 && type === MapElementType.Ligne)
    ) {
      coordinates.push(0);
      coordinates.push(0);
      if (is2D == false) {
        coordinates.push(0);
      }
    }

    if (this.controlspoints.length == 2 && type === MapElementType.Polygone) {
      const buffer = this.polygon.bufferLine(2);
      //igo test
      if(buffer !== undefined) {
        coordinates = [];
        buffer.geometry.coordinates[0].forEach((coord) => {
          coordinates.push(coord[1]);
          coordinates.push(coord[0]);
          coordinates.push(0);
        });
      }
    }

    if (this.controlspoints.length > 2 && type === MapElementType.Polygone) {
      //fermer le polygone
      coordinates.push(coordinates[0]);
      coordinates.push(coordinates[1]);
      if (is2D == false) {
        coordinates.push(coordinates[2]);
      }
    }

    return coordinates;
  }

  setControlPoint(index, cartographic) {
    if (index < this.controlspoints.length) {
      this.controlspoints[index] = cartographic;
    } else {
      // console.log("Erreur setControlPoint");
    }
    //this.viewer.scene.requestRender();
  }

  cartesian3FromCartographicDegrees(cartographic) {
    const cartesian = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    return cartesian;
  }

  CartographicDregreesToRadians(cartographic) {
    return new Cesium.Cartographic(
      Cesium.Math.toRadians(cartographic.longitude),
      Cesium.Math.toRadians(cartographic.latitude),
      cartographic.height
    );
  }

  CartographicRadiansToDregrees(cartographic) {
    return new Cesium.Cartographic(
      Cesium.Math.toDegrees(cartographic.longitude),
      Cesium.Math.toDegrees(cartographic.latitude),
      cartographic.height
    );
  }

  async updateHeightGround(index) {
    const cartographic = this.getControlPoint(index);
    const height = await Map.pickRayCast(cartographic);
    cartographic.height = height;
    //console.log("height = " + height);
    if (index < this.controlspoints.length) {
      this.setControlPoint(index, cartographic);
    }
    this.infos.point.lat = cartographic.latitude;
    this.infos.point.lon = cartographic.longitude;
  }

  setHeight(height) {
    if (this.isAbsolute == true) {
      this.infos.point["height"].WGS = height;
    } else {
      this.infos.point["height"].AGL = height;
    }
  }

  setName(name) {
    if (name === "" || name === null || name === undefined) {
      name = "Sans nom";
    }
    this.infos.name = name;
  }

  getName() {
    return this.infos.name;
  }

  setId(id) {
    this.infos.id = id;
  }

  getId() {
    return this.infos.id;
  }

  setGeom(coords) {
    //modification en cours
    if (this.events.isFreeze() || this.events.isInsert()) {
      // console.log("setGeom modif en cours");
      return;
    }

    if (this.infos.type === MapElementType.Point) {
      this.infos.point.lat = coords.latitude;
      this.infos.point.lon = coords.longitude;
      this.setHeight(coords.height);
      const cartographic = new Cesium.Cartographic(
        this.infos.point.lon,
        this.infos.point.lat,
        0
      );

      if (this.controlspoints.length == 0) {
        this.addControlPoint(cartographic);
      } else {
        cartographic.height = this.getControlPointHeight(0);
        this.setControlPoint(0, cartographic);
      }
    }
    if (
      this.infos.type === MapElementType.Polygone ||
      this.infos.type === MapElementType.Ligne
    ) {
      if (this.controlspoints.length != coords.length) {
        this.removeControlPoints();
        this.controlspoints = [];
      }
      if (this.controlspoints.length == 0) {
        coords.forEach((coord) => {
          const cartographic = new Cesium.Cartographic(
            coord.longitude,
            coord.latitude,
            0
          );
          this.addControlPoint(cartographic);
        });
      } else {
        for (let idx = 0; idx < this.controlspoints.length; idx++) {
          const cartographic = new Cesium.Cartographic(
            coords[idx].longitude,
            coords[idx].latitude,
            this.getControlPointHeight(idx)
          );
          this.setControlPoint(idx, cartographic);
        }
      }
    }
    //this.forceUpdateInfos();
  }

  addControlPoint(cartographic, index) {
    if (index === undefined) {
      index = this.controlspoints.length;
    } else {
      this.controlspointsEntities.forEach((controlspointsEntity) => {
        if (controlspointsEntity.index >= this.polygon.insertPoint.index + 1) {
          controlspointsEntity.index += 1;
        }
      });
    }

    const entity = {
      //index: index,
      position: new Cesium.CallbackProperty(() => {
        return this.getControlPointCartesian(index);
      }, false),
      billboard: {
        image:  this.material.getSvgCircle(index),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BASELINE,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0.0,
          this.max_distance_show ,
        ),
        scale:1,
        sizeInMeters: false,
        width:new Cesium.CallbackProperty(() => {
          return this.getontrolPointSize(index);
        }, false),
        height:new Cesium.CallbackProperty(() => {
          return this.getontrolPointSize(index);
        }, false),
        show: new Cesium.CallbackProperty(() => {
          return this.getControlPointVisibility();
        }, false),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.NONE
        //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      },

      /* point: {
        color: Cesium.Color.WHITE,
        pixelSize: 4,
       // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      },*/
      /*
      ellipsoid: {

        radii: new Cesium.CallbackProperty(() => {
          return this.getControlPointRadius(index);
        }, false),
        material: Cesium.Color.WHITE.withAlpha(0.8),
        show: new Cesium.CallbackProperty(() => {
          return this.getVisibility();
        }, false),

      },
      */
      allowPicking: false,
    };

    this.controlspoints.splice(index, 0, cartographic);

    const elem = this.datasource.entities.add(entity);
    elem.index = index;
    this.controlspointsEntities.push(elem);
  }

  removeControlPoint(index) {
    const entities = this.controlspointsEntities.filter(
      (controlspointsEntity) => controlspointsEntity.index == index
    );
    let newval = [];
    let newentities = [];

    if (entities.length > 0) {
      const entity = entities[0];
      this.controlspointsEntities.forEach((controlspointsEntity) => {
        if (controlspointsEntity.index >= index + 1) {
          controlspointsEntity.index -= 1;
        }
      });

      this.datasource.entities.remove(entity);
      for (let i = 0; i < this.controlspoints.length; i++) {
        if (i != index) {
          newval.push(this.getControlPoint(i));
        }
      }
      for (let i = 0; i < this.controlspointsEntities.length; i++) {
        if (i != index) {
          newentities.push(this.controlspointsEntities[i]);
        }
      }
      this.controlspointsEntities = newentities;
      this.controlspoints = newval;
    }
  }

  getontrolPointSize(index) {
    if(this.events.isOpen() && this.events.isControlPointPicked(index)){
      return 8;
    }
    return 4;
  }
/*
  getControlPointRadius(index) {
    let size = 1;
    if (this.events.isOpen() && this.events.isControlPointPicked(index)) {
      size = 2;
    }
    return new Cesium.Cartesian3(size, size, size);
  }*/

  removeControlPoints() {
    this.controlspointsEntities.forEach((entity) => {
      this.datasource.entities.remove(entity);
    });
  }
/*
  async pickRayCast(cartographic) {

    if (this.viewer.terrainProvider === undefined) {
      return 0;
    }
    const cartesianUp = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height + 100
    );
    const cartesianDown = Cesium.Cartesian3.fromDegrees(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    const direction = Cesium.Cartesian3.normalize(
      Cesium.Cartesian3.subtract(
        cartesianDown,
        cartesianUp,
        new Cesium.Cartesian3()
      ),
      new Cesium.Cartesian3()
    );
    const ray = new Cesium.Ray(cartesianUp, direction);
    const intersec = this.viewer.scene.pickFromRay(
      ray,
      this.datasource.entities.values
    );
    if (intersec !== undefined && Cesium.defined(intersec.position)) {
      const cartographicRadians = Cesium.Cartographic.fromCartesian(
        intersec.position
      );
      if (cartographicRadians.height >= 0) {
        return cartographicRadians.height;
      }
    }

    const cartographicDegrees = await this.getsampleTerrainHeight(cartographic);
    if (Cesium.defined(cartographicDegrees)) {
      return cartographicDegrees.height;
    }

    return 0;
  }*/
/*
  async getsampleTerrainHeight(cartographic) {
    const cartographicRadian = this.CartographicDregreesToRadians(cartographic);
    //const sample = await Cesium.sampleTerrainMostDetailed(
    const sample = await Cesium.sampleTerrain(
      this.viewer.terrainProvider,
      11,
      [cartographicRadian]
    );
    if (sample.length > 0) {
      if (Cesium.defined(sample[0])) {
        return this.CartographicRadiansToDregrees(sample[0]);
      }
    }
    return undefined;
  }*/

  sauve() {
    this.sauvcontolpoints = this.controlspoints.slice();
  }
  restore() {
    if (this.sauvcontolpoints.length > 0) {
      this.controlspoints = this.sauvcontolpoints.slice();
      this.sauvcontolpoints = [];
    }
  }

  openContextMenu() {
    const index = this.events.getIndexControlPoint();
    const cartographic = this.getControlPoint(index);
    if (Cesium.defined(cartographic)) {
      const asl = egm96.ellipsoidToEgm96(
        cartographic.latitude,
        cartographic.longitude,
        cartographic.height
      );
      let info = {
        id: this.getId(),
        index: index,
        lat: cartographic.latitude.toFixed(8),
        lng: cartographic.longitude.toFixed(8),
        asl: asl.toFixed(2),
        pos_x: this.pickedInfos.endPosition.x,
        pos_y: this.pickedInfos.endPosition.y,
      };

      this.events.activateContextMenu(info);
    }
  }
}
